import React, { useState } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";

const MessageComposer = ({ onSend, disabled }) => {
  const [text, setText] = useState("");

  const handleSend = () => {
    if (!text.trim()) return;
    onSend(text);
    setText("");
  };

  const handleKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="message-composer">
      <InputTextarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={handleKey}
        rows={1}
        autoResize
        placeholder="Type a message…"
        disabled={disabled}
      />
      <Button
        icon="pi pi-send"
        className="p-button-rounded"
        onClick={handleSend}
        disabled={disabled || !text.trim()}
      />
    </div>
  );
};

export default MessageComposer;
